<template>
  <v-container>
    <v-banner
      v-if="deferredPrompt"
      color="info"
      class="text-left"
    >
      アプリをインストール頂くと、より便利にご利用頂けます。
      <template v-slot:actions>
        <v-btn text @click="dismiss">また今度</v-btn>
        <v-btn text @click="install">インストール</v-btn>
      </template>
    </v-banner>

    <v-card width="400px" class="mx-auto mt-5">
      <v-card-title>
        <h1 class="display-1">在庫管理システム</h1>
      </v-card-title>
      <v-card-text>
        <form v-on:submit.prevent="doLogin">
            <v-select prepend-icon="mdi-office-building" :options="kaisyaList" v-model="selectedKaisya" dense :clearable=false></v-select>
            <v-text-field :rules="[required,number]" label="社員番号" prepend-icon="mdi-account-circle" class="inputShain" type="number" v-model="user.shaincd" clearable />
            <v-text-field :rules="[required]" v-bind:type="showPassword ? 'text' : 'password'" prepend-icon="mdi-lock" v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" label="パスワード" @click:append="showPassword = !showPassword" v-model="user.password" />
            <v-card-actions>
              <v-btn @click="doLogin" class="info">ログイン</v-btn>
            </v-card-actions>
        </form>
        </v-card-text>
    </v-card>
    <br>
    <v-alert type="error" v-if="api_error">
        社員番号、またはパスワードを<br>
        確認してください
    </v-alert>
  </v-container>
</template>

<script>
import axios from "axios"
import vSelect from 'vue-select'
axios.defaults.withCredentials = false;

export default {
  name: 'Login',
  components: {
    vSelect
  },
  data() {
    return {
      deferredPrompt: null,
      showPassword : false,
      kaisyaList: [],
      selectedKaisya: {label: 'アークミール', code: '1070'},
      api_error: false,
      user: {kaisyacd:"", shaincd:"", shainName:"", password:"", tenpocd:"", tenpoName:"", api_token:"", version:""},
      required: value => !!value || "必ず入力してください",
      number: value => !isNaN(value) || "数字を入力してください",
    };
  },
  created () {
    axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
    window.addEventListener("beforeinstallprompt", e => {
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    });

    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
    // 最新APIバージョン取得 & 会社リスト取得
    this.getAPIVersion();

    // APIトークンの有効性チェックをして、OKならログイン
    //TODO: 自動ログイン（自動ログインしない場合は、ヘッダが表示されないようにトークンをクリア）
    if(this.$store.state.api_token){
      console.log('do AutoLogin');
      this.$store.state.api_token = null;
    }
  },
  methods: {
    async dismiss() {
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    autoLogin(){
      // APIトークンの有効チェック
      axios
        .get( "/api/check_api_token.php",
        {
          params: {
            api_token: this.$store.state.api_token
          }
        }
        )
        .then(
          response => (
            console.log(response.data.result)
            )
        )
        .catch(error => (
          console.log(error)
        ))
    },
    getAPIVersion(){
      // APIバージョン情報を取得
      axios
        .get( "/api/get_api_verion.php")
        .then(
          response => (
            this.clearCache(response.data),
            this.getKaisyaVersion()
            )
        )
        .catch(error => (
          console.log(error)
        ))
    },
    getKaisyaVersion(){
      // APIバージョン情報を取得
      axios
        .get( "/api/get_kaisya.php")
        .then(
          response => (
            this.api_result = response.data,
            this.setKaisyaSelector()
            )
        )
        .catch(error => (
          console.log(error)
        ))
    },
    setKaisyaSelector: function() {
      this.api_result.forEach(element => {
        this.kaisyaList.push({label: element.name, code: element.code});
      })
    },
    clearCache(data){
      try {
        var api_version = data[0].version;
        console.log("ローカルバージョン：" + this.$store.state.version);
        console.log("最新バージョン：" + api_version);
        console.log(api_version != this.$store.state.version);
        // バージョンが異なる場合は、キャッシュをクリア＆リロード
        if(this.$store.state.version && api_version != this.$store.state.version){
          console.log("ServiceWorkerのクリア");
          alert("新しいバージョンに更新しました");
          // LocalStorage へ保管する
          this.$store.dispatch("apiData", {
            version: api_version
          });
          // ServiceWorkerのクリア
          window.navigator.serviceWorker.getRegistrations()
          .then(registrations => {
            for(let registration of registrations) {
              registration.unregister();
            }
          });
          // 画面リロード
          window.location.reload(true);
        } else {
          // 現在のバージョンを保管
          this.$store.dispatch("apiData", {
            version: api_version
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    doLogin() {
      if (this.user.shaincd && this.user.password) {
        this.api_error = false,
        axios
          .post( "/api/get_api_token.php",
          {
            kaisyacd: this.selectedKaisya.code,
            shaincd: this.user.shaincd,
            password: this.user.password
          })
          .then(
            response => (
              this.user.api_token = response.data.result.api_token,
              this.user.shainName = response.data.result.shainnm,
              this.user.tenpocd = response.data.result.tenpocd,
              this.user.tenpoName = response.data.result.tenponm,
              this.storeLoginData()
              )
          )
          .catch(error => (
            this.api_error = true
          ))
      }
    },
    storeLoginData: function (){
      // LocalStorage へ保管する
      this.$store.dispatch("auth", {
        kaisyacd: this.selectedKaisya.code,
        shaincd: this.user.shaincd,
        shainName: this.user.shainName,
        api_token: this.user.api_token
      });
      this.$store.dispatch("tenpo", {
        tenpoCd: this.user.tenpocd,
        tenpoName: this.user.tenpoName
      });
      this.$router.push({name: 'Top'}).catch(()=>{});
    },
  }
};
</script>

<style scoped>
.inputShain >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputShain >>> input::-webkit-outer-spin-button,
.inputShain >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>